export const homeObjTwo = {
  primary: true,
  lightBg: false,
  lightTopLine: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Outdoor Inline Hockey Rink',
  headline: 'Team up with First Coast Hockey Organization.',
  description:'This facility will be top of the line and will help grow the sport of hockey while providing a positive environment for children.',
  buttonLabel: 'Help Us',
  imgStart: '',
  img: require('../../images/hockeyrink2.jpg').default,
  img2: require('../../images/hockeyrink1.jpg').default,
  img3: require('../../images/hockeyrink3.jpg').default,
  alt: 'Vault',
  start: ''
};
